import { ChainId } from '@pulsex/chains'

export const SUPPORT_ONLY_PULSE = [ChainId.PULSECHAIN, ChainId.PULSECHAIN_TESTNET]
export const SUPPORT_FARMS = [ChainId.PULSECHAIN, ChainId.PULSECHAIN_TESTNET]

export const SUPPORT_ZAP = [ChainId.PULSECHAIN, ChainId.PULSECHAIN_TESTNET]
